import { render, staticRenderFns } from "./InventoryMonitorSector.vue?vue&type=template&id=2a6c7791"
import script from "./InventoryMonitorSector.vue?vue&type=script&lang=js"
export * from "./InventoryMonitorSector.vue?vue&type=script&lang=js"
import style0 from "./InventoryMonitorSector.vue?vue&type=style&index=0&id=2a6c7791&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports